var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaltrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M74.353,61.98L57.505,45.982c-0.642-0.611-1.61-0.725-2.377-0.282l-5.431,3.136c-0.619,0.357-1,1.017-1,1.732v6.271 c0,0.886,0.583,1.666,1.433,1.918l22.278,6.591c0.188,0.056,0.379,0.082,0.567,0.082c0.7,0,1.368-0.369,1.732-1 C75.17,63.63,75.023,62.617,74.353,61.98z M52.697,55.346v-3.623l3.137-1.811l9.732,9.241L52.697,55.346z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.303,48.836l-5.431-3.135c-0.769-0.443-1.735-0.329-2.377,0.282L21.647,61.98c-0.67,0.637-0.817,1.649-0.355,2.45 c0.364,0.631,1.032,1,1.732,1c0.188,0,0.379-0.026,0.567-0.082l22.278-6.591c0.85-0.252,1.433-1.032,1.433-1.918v-6.271 C47.303,49.854,46.921,49.193,46.303,48.836z M43.303,55.346l-12.869,3.808l9.732-9.241l3.137,1.811V55.346z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.431,44.493c0.768-0.443,1.151-1.338,0.944-2.199l-5.431-22.589c-0.216-0.899-1.02-1.533-1.944-1.533 s-1.729,0.634-1.944,1.532l-5.431,22.589c-0.208,0.862,0.177,1.757,0.944,2.2L47,47.628c0.31,0.179,0.655,0.268,1,0.268 s0.69-0.089,1-0.268L54.431,44.493z M44.863,41.776L48,28.728l3.137,13.048L48,43.587L44.863,41.776z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaltrop);
export default __webpack_public_path__ + "static/media/caltrop.8198a8e12c40a3e1fb4a214c0e751fa7.svg";
export { ForwardRef as ReactComponent };